export function getFileExtension(fileName: string): string | undefined {
	const parts = fileName.split(".");
	return parts[parts.length - 1];
}
